import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import DetailView from './detail-view';
import useReview from '../../../hooks/use-review';

const DetailContainer = () => {
  const { state } = useLocation();
  const localStateReview = state?.data?.review;
  const { reviewId } = useParams();
  const [review, loading, error] = useReview(localStateReview ? undefined : reviewId);

  return (
    <DetailView
      review={localStateReview || review}
      loading={loading}
      error={error}
    />
  );
};

export default DetailContainer;
